module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBd.woff?v=56e369a7c73aaf36318f690856cb6bff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBd.woff
// module id = 683
// module chunks = 0